import React, { Component } from "react";
import { Row, Col, Container } from 'react-bootstrap'
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from "react-device-detect";
import StudentPermissionHome from '../components/studentPermission/StudentPermissionHome'
import { StudentPermissionShimmer } from '../components/studentPermission/StudentPermissionShimmer'
import { canView } from "../../utils/modulePermissions";

const FETCH_PARENT_PERMISSION = gql`
query($institute_id: Int!) {
  getParentsPermissionDetails(institute_id: $institute_id) {
    class_id
    branch_id
    section_id
    class_name
    branch_name
    section_name
    permission_id
    student_name
    roll_no
    student_mobile
    request_date
    from_datetime
    to_datetime
    receiver_name
    receiver_mobile
    receiver_relation
    request_message
    receiver_image_path
    parent_name
    parent_mobile
    permission_status
    comments
    approved_time
    approved_by
    outtime
    outtime_image_path
    outtime_inserted_by
    intime
    intime_image_path
    intime_inserted_by
    permission_request_type_id
    request_title
  }
}
`;

const FETCH_PERMISSION_REQUEST_TYPES = gql`
query($id: Int) {
  getPermissionRequestTypes(id: $id) {
    id
    permission_request_type
  }
}
`;


export class StudentPermission extends Component {
  constructor(props) {
    super(props)
    this.state = {
      toggled: Cookies.get("toggle")
    }
  }
  menuToggler = () => {
    const toggled = Cookies.get("toggle");
    if (toggled === "wrapper") {
      this.setState({ toggled: "wrapper sidebar-enable" });
      Cookies.set("toggle", "wrapper sidebar-enable");
    } else {
      this.setState({ toggled: "wrapper" });
      Cookies.set("toggle", "wrapper");
    }
  };
  render() {
    if (Cookies.get("token") == undefined) this.props.history.push("/login");

    // When the queries are skipped (is_view === 0) react-apollo passes no data prop at
    // all, so default them — StudentPermissionHome renders Access Denied in that case,
    // and with loading undefined it falls straight through to it instead of shimmering
    // forever waiting on data that will never arrive.
    const getParentsPermissionDetails = this.props.getParentsPermissionDetails || {};
    const loading3 = getParentsPermissionDetails.loading;
    const error3 = getParentsPermissionDetails.error;

    const getPermissionRequestTypes = this.props.getPermissionRequestTypes || {};
    const loading4 = getPermissionRequestTypes.loading;
    const error4 = getPermissionRequestTypes.error;

    if (error3 !== undefined) {
      alert("Server Error. " + error3.message);
      return null;
    }
    if (error4 !== undefined) {
      alert("Server Error. " + error4.message);
      return null;
    }

    return (
      <div className={Cookies.get("toggle")}>
        <div className="header-area">
          <NavbarOne onClick={() => this.menuToggler()} />
        </div>
        <div className="main-wrapper">

          <div id="sidebar" className={isBrowser == true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
            <SideNavbar />
          </div>
          <div className="student-overlay" onClick={() => this.menuToggler()} />
          <div className="content-wrapper mb-2">
            {
              loading3 || loading4 ?
                (
                  <StudentPermissionShimmer />
                )
                :
                (
                  <StudentPermissionHome
                    getParentsPermissionDetails={getParentsPermissionDetails.getParentsPermissionDetails}
                    getPermissionRequestTypes={getPermissionRequestTypes.getPermissionRequestTypes}
                    refetchPermissions={getParentsPermissionDetails.refetch}
                  />
                )}
          </div>
          <Footer />
        </div>
      </div>
    )
  }
}

// The permission READ queries live on this page, not in StudentPermissionHome, so the
// is_view skip has to sit here — otherwise the data would be fetched and cached even
// though the home component renders Access Denied.
// module_key ONLY, never module_name (the sidebar group is shared by sibling modules).
const PERMISSIONS_MODULE = ["Permissions"];
const skipUnlessViewable = () => !canView(PERMISSIONS_MODULE);

export default withRouter(
  compose(
    graphql(FETCH_PARENT_PERMISSION, {
      options: (props) => ({
        variables: {
          institute_id: parseInt(Cookies.get("institutionid")),
        },
        fetchPolicy: "cache-and-network",
      }),
      skip: skipUnlessViewable,
      name: "getParentsPermissionDetails",
    }),
    graphql(FETCH_PERMISSION_REQUEST_TYPES, {
      options: (props) => ({
        variables: {
          id: parseInt(Cookies.get("institutionid")),
        },
        fetchPolicy: "cache-and-network",
      }),
      skip: skipUnlessViewable,
      name: "getPermissionRequestTypes",
    }),
  )
    (StudentPermission));
